exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".text-sm[_v-40a62f1c]{margin-left:33px}.info-box-lg[_v-40a62f1c]{padding:45px 15px 45px 33px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-40a62f1c&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Admin/Admin-products-shipping-edit.vue
// module id = 425
// module chunks = 0